import { IconButton, type IconButtonProps } from '@chakra-ui/react';

import { ADVISOR_PANEL_NEUTRAL_100 } from './advisor-panel-tokens';

/** 30×30 bordered control — Figma AI Chat Modal Top (node 10937:72256). */
export function AdvisorPanelHeaderIconButton(props: IconButtonProps) {
  return (
    <IconButton
      variant="ghost"
      w="30px"
      minW="30px"
      h="30px"
      borderRadius="4px"
      borderWidth="1px"
      borderColor={ADVISOR_PANEL_NEUTRAL_100}
      color="gray.800"
      _hover={{ bg: 'gray.50' }}
      {...props}
    />
  );
}

export const AgentPanelHeaderIconButton = AdvisorPanelHeaderIconButton;
